import numeral from 'numeral';

const keys = [
    {
        key: 'clicks',
        label: 'Avg. Clicks',
        icon: 'clicks',
    },
    {
        key: 'impressions',
        label: 'Avg. Impressions',
        icon: 'search',
    },
    {
        key: 'position',
        label: 'Avg. Position',
        icon: 'pagev-view',
        yAxisID: 'y1',
    },
    {
        key: 'ctr',
        label: 'Avg. CTR',
        format: '0.00%',
        yAxisID: 'y1',
        render: (data, item) => {
            const ctr = item?.clicks / item?.impressions;
            return numeral(ctr * 100).format('0.00');
        },
        icon: 'ctr',
    },
];

export const tooltips = {
    ALL: '',
    DISCOVER: 'Discover results',
    GOOGLENEWS:
        'Results from news.google.com and the Google News app on Android and iOS. Doesn\'t include results from the "News" tab in Google Search.',
    IMAGE: 'Search results from the "Image" tab in Google Search.',
    VIDEO: 'Video search results',
    NEWS: 'Search results from the "News" tab in Google Search.',
    WEB: ' results to the combined ("All") tab in Google Search. Does not include Discover or Google News results.',
};

export default keys;
